import { render, staticRenderFns } from "./ComboContent.vue?vue&type=template&id=2e04087d"
import script from "./ComboContent.vue?vue&type=script&lang=js"
export * from "./ComboContent.vue?vue&type=script&lang=js"
import style0 from "./ComboContent.vue?vue&type=style&index=0&id=2e04087d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports